const baseUrl = {
    sandbox: {
        account: 'https://accounts.ronad.ir/realms/r2-staging',
        panel: 'https://partner.sb.ronad.ir'
    },
    production: {
        account: 'https://accounts.ronad.ir/realms/r2',
        panel: 'https://partner.ronad.ir'
    },
    qa: {
        account: 'https://accounts.ronad.ir/realms/r2-staging',
        panel: 'https://partner.qa.ronad.ir'
    }
}

const getEnv = () => {
    const env = process.env.REACT_APP_ENVIROMENT || 'qa'
    return baseUrl[env]
}
export default getEnv